var _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviati(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 72 72",
    id: "emoji",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.187 0 0 1.188 -8.324 -10.3)",
    fill: "#fcea2b",
    stroke: "#fcea2b",
    strokeLinecap: "round",
    strokeWidth: 1.532,
    d: "m33.59 59.58c1.617 1.699 4.094-3.063 4.809-4.103 2.298 1.695 8.481 3.023 7.537-1.592 1.225 0.448 5.037 0.6612 3.849-3.45 3.047 1.486 5.646-0.8396 5.245-3.457 2.698 0.4885 4.347-1.715 3.588-4.344 4.063-5.1 3.828-11.69 3.595-14.66-0.7777-9.896-14.08-6.154-20.2-10.02l-12.99 0.05163c-2.202 3.942-3.569 1.824-7.728 2.337-6.072 0.8894-11.08 16.24-9.519 16.94l7.732 8.23c0.1394 1.526-3.91 4.042-0.3566 5.882 6.126 2.159 10.32 5.064 14.45 8.183z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m15.05 43.95s-7.133-5.822-8.537-8.259c-4.392-7.595 0.9489-19.79 10.44-21.82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m38.71 42.99 12.89 7.021"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m33.87 47.79 13 6.498"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m58.18 45.72-5.1-4.358-8.279-4.335"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m37.49 56.29c8.574 5.466 10.79-0.2955 9.387-1.994 2.734 1.625 6.209-0.517 4.731-4.283 3.844 1.847 7.022-1.034 6.579-4.283 3.326 0.591 5.395-2.142 4.435-5.392 6.721-4.585 5.041-19.03-0.09878-25.36-9.287-1.459-11-2.362-20.98-3.943l-13.53-0.6185c-2.005-0.529-4.081 0.5703-4.779 2.533-0.7519 2.816-1.677 4.971-3.599 8.378-0.7286 1.786 0.1048 3.829 1.872 4.588 1.908 0.4767 2.78-0.386 4.46-1.686 2.195-2.102 2.628-2.996 3.805-4.575l13.64 6.204 12.72 7.164c2.514 1.698 5.012 5.844 6.51 7.321"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m31.51 54.15c1.109-1.477 2.666-1.713 4.144-0.9003 1.405 0.8125 2.439 2.362 1.478 4.063l-1.774 3.101c-1.109 1.477-3.178 1.698-4.582 0.6647-1.234-0.9245-1.592-2.518-1.076-3.836 1.81-3.094 0 0 1.81-3.094z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m25.84 50.98c1.109-1.477 2.666-1.713 4.144-0.9003 1.405 0.8125 2.439 2.362 1.478 4.063l-1.774 3.101c-1.109 1.477-3.178 1.698-4.582 0.6647-1.234-0.9245-1.592-2.518-1.076-3.836 1.81-3.094 0 0 1.81-3.094z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m20.18 47.82c1.109-1.477 2.666-1.713 4.144-0.9003 1.405 0.8125 2.439 2.362 1.478 4.063l-1.774 3.101c-1.109 1.477-3.178 1.698-4.582 0.6647-1.234-0.9245-1.592-2.518-1.076-3.836 1.81-3.094 0 0 1.81-3.094z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m14.53 44.65c1.109-1.477 2.666-1.713 4.144-0.9003 1.405 0.8125 2.439 2.362 1.478 4.063l-1.774 3.101c-1.109 1.477-3.178 1.698-4.582 0.6647-1.234-0.9245-1.592-2.518-1.076-3.836 1.81-3.094 0 0 1.81-3.094z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviati);
export default __webpack_public_path__ + "static/media/inviati.39280f913b772f7d9cb7e94d3d5caa10.svg";
export { ForwardRef as ReactComponent };